<template>
  <pt-goods-group class="pt-goods-group__withData" @deleteGroup="deleteGroup" ref="tablePage"></pt-goods-group>
</template>

<script>
import PtGoodsGroup from './index'
export default {
  name: 'pt-goods-group__withData',
  components: {
    'pt-goods-group': PtGoodsGroup
  },
  methods: {
    deleteGroup (val) {
      this.$store.dispatch('groupDelete', val.id).then(res => {
        this.$message.success('删除商品成功')
        this.$refs.tablePage.optionSuccess()
      }).catch(err => {
        this.$message.eror(err || '删除商品分组失败')
      })
    }
  }
}
</script>
